import { destroy, get, post, patch, transformRequestData } from "./utils/requests"

export interface SchemaResponse {
  models: Array<SchemaResponseResource>
}

export interface SchemaResponseResource {
  resource: string
  model: string
  fields: Array<{ name: string; type: string }>
  sub_resources: Array<Omit<SchemaResponseResource, "sub_resources">>
}

const schema = (): Promise<SchemaResponse> => get(`/api/dynamic_forms/metadata`)

const metadata = (model: string) => get(`/api/dynamic_forms/metadata/${model}`)

const fetchAll = (model: string, campId: string, perPage = 50, q?: string, page = 1): Promise<{ records: any[]; total: number }> => get(`/api/dynamic_forms/entrypoint/${model}`, { camp_id: campId, per_page: perPage, ...(q ? { q } : {}), page })

const show = (model: string, campId: string, id: string): Promise<{ record: any }> => get(`/api/dynamic_forms/entrypoint/${model}/${id}`, { camp_id: campId })

const create = (model: string, campId: string, data: Record<string, unknown>) =>
  post("/api/dynamic_forms/entrypoint", transformRequestData({ model, camp_id: campId, ...data }))

const update = (model: string, campId: string, id: string, data: Record<string, unknown>) =>
  patch(`/api/dynamic_forms/entrypoint/${id}`, transformRequestData({ model, camp_id: campId, ...data }))

const remove = (model: string, campId: string, id: string) =>
  destroy(`/api/dynamic_forms/entrypoint/${id}`, transformRequestData({ model, camp_id: campId }))

const DynamicForms = { schema, metadata, fetchAll, show, create, update, remove }

export default DynamicForms
